import { request } from './request';

export const createCustomerDoctors = (body) => {
  return request(`customer_doctors`, { method: 'POST', body });
};
